export const PROFILE_REQUEST = `[user] Profile request` as const;
export const PROFILE_SUCCESS = `[user] Profile success` as const;
export const PROFILE_FAILED = `[user] Profile failed` as const;

export const CLEAR_ERROR = `[user] Clear error` as const;
